var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51313 2.93895C7.51724 2.14462 8.18246 1.5 9 1.5C9.81754 1.5 10.4828 2.14462 10.4869 2.93895H12.2908V3.14929H13.3561C13.6951 3.14929 14.0139 3.25063 14.2758 3.42267C14.5373 3.59491 14.7454 3.838 14.8704 4.12558C14.9545 4.31783 15 4.52918 15 4.74838V14.9014C15 15.2307 14.8958 15.5408 14.719 15.7955C14.5421 16.0496 14.2923 16.2526 13.996 16.3738C13.7987 16.4558 13.5809 16.5 13.3561 16.5H4.64391C4.30505 16.5 3.98664 16.3992 3.72412 16.2266C3.46262 16.0543 3.25464 15.8113 3.12962 15.5237C3.0461 15.3319 3 15.1201 3 14.9014V4.74838C3 4.41857 3.10423 4.10896 3.28096 3.85388C3.45812 3.59941 3.70861 3.39693 4.00413 3.27537C4.20104 3.19403 4.41808 3.14929 4.64391 3.14929H5.70927V2.93895H7.51313ZM8.32985 2.94633C8.32989 2.58662 8.6309 2.2945 9 2.2945C9.36969 2.2945 9.67012 2.58674 9.67012 2.94635L8.32985 2.94633ZM5.70924 4.3574H4.64425C4.55882 4.35778 4.48385 4.38199 4.41906 4.42415C4.35519 4.46602 4.30379 4.52645 4.27356 4.59616C4.25341 4.64233 4.24198 4.69301 4.24198 4.74838V14.901C4.24236 14.9834 4.26715 15.0563 4.31044 15.1193C4.35452 15.1824 4.41652 15.2324 4.48728 15.2615C4.5352 15.2809 4.58712 15.2919 4.64391 15.2919H13.3561C13.441 15.2919 13.5158 15.2679 13.5806 15.2258C13.6455 15.1827 13.6967 15.1221 13.7263 15.0535L13.7266 15.0527C13.7468 15.0064 13.758 14.9566 13.758 14.9014V4.74835C13.758 4.66551 13.7332 4.59285 13.6896 4.53002C13.6459 4.46704 13.5837 4.41713 13.5129 4.38828L13.5121 4.38796C13.4647 4.36836 13.413 4.3574 13.3561 4.3574H12.2907C12.2866 4.7846 11.9294 5.12958 11.4893 5.12958H6.51111C6.0706 5.12958 5.71333 4.78469 5.70924 4.3574Z",
    fill: "white",
    fillOpacity: 0.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2522 7.3125C12.2522 7.62316 11.9933 7.875 11.674 7.875H8.20439C7.88502 7.875 7.62612 7.62316 7.62612 7.3125C7.62612 7.00184 7.88502 6.75 8.20439 6.75L11.674 6.75C11.9933 6.75 12.2522 7.00184 12.2522 7.3125Z",
    fill: "white",
    fillOpacity: 0.74
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8551 7.3125C6.8551 7.62316 6.5962 7.875 6.27684 7.875C5.95747 7.875 5.69857 7.62316 5.69857 7.3125C5.69857 7.00184 5.95747 6.75 6.27684 6.75C6.5962 6.75 6.8551 7.00184 6.8551 7.3125Z",
    fill: "white",
    fillOpacity: 0.74
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2522 9.9375C12.2522 10.2482 11.9933 10.5 11.674 10.5H8.20439C7.88502 10.5 7.62612 10.2482 7.62612 9.9375C7.62612 9.62684 7.88502 9.375 8.20439 9.375H11.674C11.9933 9.375 12.2522 9.62684 12.2522 9.9375Z",
    fill: "white",
    fillOpacity: 0.74
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8551 9.9375C6.8551 10.2482 6.5962 10.5 6.27684 10.5C5.95747 10.5 5.69857 10.2482 5.69857 9.9375C5.69857 9.62684 5.95747 9.375 6.27684 9.375C6.5962 9.375 6.8551 9.62684 6.8551 9.9375Z",
    fill: "white",
    fillOpacity: 0.74
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2522 12.5625C12.2522 12.8732 11.9933 13.125 11.674 13.125H8.20439C7.88502 13.125 7.62612 12.8732 7.62612 12.5625C7.62612 12.2518 7.88502 12 8.20439 12H11.674C11.9933 12 12.2522 12.2518 12.2522 12.5625Z",
    fill: "white",
    fillOpacity: 0.74
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8551 12.5625C6.8551 12.8732 6.5962 13.125 6.27684 13.125C5.95747 13.125 5.69857 12.8732 5.69857 12.5625C5.69857 12.2518 5.95747 12 6.27684 12C6.5962 12 6.8551 12.2518 6.8551 12.5625Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/surveys.c3735e1d2679de0de8fb019bdf0a1f15.svg";
export { ForwardRef as ReactComponent };